export default __webpack_public_path__ + "images/logoVeganMia.2e66656314c5ff786be8808fa784fb2d.svg"